export default __webpack_public_path__ + "static/media/video_play_icon_hover.165d20da.svg";